import { useContext, useEffect, useState } from 'react'
import { StatisticsContext } from '../../../context/StatisticsContext'
import StatisticsService from '../../../services/StatisticsService'
import { statisticsColors } from '../StatisticsPage'
import CustomPaper from '../../../containers/Paper'
import { Radar } from 'react-chartjs-2'
import { CircularProgress } from '@mui/material'
import CustomDropdown from '../../../components/Dropdown'

interface DataType {
    jobTitle: string
    count: number
}

const CommonAbilities = () => {
    const { startDate, endDate, carreer } = useContext(StatisticsContext)
    const [data, setData] = useState<DataType[]>()
    const [roleNumbers, setRoleNumbers] = useState<string>('10')

    useEffect(() => {
        new StatisticsService()
            .getCommonAbilities(carreer, startDate, endDate, roleNumbers)
            .then((response) => {
                if (response.status !== 200) return
                setData(response.data)
            })
    }, [carreer, startDate, endDate, roleNumbers])

    const getChartData = () => {
        return {
            labels: data?.map((x) => x.jobTitle),
            datasets: [
                {
                    label: 'Cantidad de graduados',
                    data: data?.map((x) => x.count ?? 0),
                    backgroundColor: statisticsColors.background,
                    borderColor: statisticsColors.border,
                    borderWidth: 1,
                    fill: false,
                },
            ],
        }
    }

    const options = {
        scales: {
            r: {
                beginAtZero: true,
            },
        },
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label(context: any) {
                        const label: string = context.dataset.label
                        const value = context.raw
                        return `${label}: ${value}`
                    },
                },
            },
        },
    }

    return (
        <CustomPaper className={`flex flex-col gap-2 h-[400px] text-primary`}>
            <div className="flex items-start justify-between">
                <span className="text-lg font-semibold max-w-[60%]">
                    Aptitudes más frecuentes entre los graduados
                </span>
                <CustomDropdown
                    className="w-[100px] h-[40px]"
                    label="Cantidad"
                    value={roleNumbers}
                    onChange={(e) => setRoleNumbers(e.target.value as string)}
                    data={['5', '10', '15', '20']}
                />
            </div>
            <div className="flex-1 flex justify-center items-center">
                {data ? (
                    <Radar
                        data={getChartData()}
                        options={options}
                    />
                ) : (
                    <div className="w-full h-full flex justify-center items-center">
                        <CircularProgress
                            className="m-2 md:m-5 text-primary"
                            size={64}
                        />
                    </div>
                )}
            </div>
        </CustomPaper>
    )
}

export default CommonAbilities
